import {
  getInconsistencySourceDisplayName,
  InconsistencyType,
} from '../../../backend/src/matter/inconsistency/inconsistency-display';
import { InconsistencySource } from '../../../backend/src/matter/inconsistency/inconsistency-display';

export const relevanceMapping = {
  relevant: 'Relevant',
  notRelevant: 'Not Relevant',
  maybeRelevant: 'Maybe Relevant',
};

export const relevanceIcons = {
  relevant: 'lucide--circle-check',
  maybeRelevant: 'lucide--circle-question-mark',
  notRelevant: 'lucide--circle-x',
};

export const capitalizeFirstLetter = (filter: string) => {
  return filter.charAt(0).toUpperCase() + filter.slice(1);
};

export const transformFilterName = (filter: string, filterType?: string) => {
  if (filterType === 'inconsistencySource') {
    return getInconsistencySourceDisplayName(filter as InconsistencySource);
  }
  if (filterType === 'inconsistencyType' && filter === InconsistencyType.Evolving) {
    return 'Changing Testimony';
  }
  if (filterType === 'factRelevance') {
    return relevanceMapping[filter as keyof typeof relevanceMapping];
  }
  return capitalizeFirstLetter(filter);
};
